// Data layer for the legacy-user "Review Your Subscription Update" page.
//
// The whole flow reuses the existing v2 subscription endpoints — no new backend is required:
//   - GET   /api/v2/accounts/subscription/          -> current subscription (works for legacy users,
//                                                       returns user_type: "traditional")
//   - GET   /api/v2/accounts/registration/          -> product catalogue, used to resolve the
//                                                       AI Tracking monthly price for the preview
//   - PATCH /api/v2/accounts/subscription/?preview=true -> itemized invoice preview for the change
//                                                       (lines + subtotal/discount/total/amount due)
//   - PATCH /api/v2/accounts/subscription/          -> confirm: migrates the legacy user and adds
//                                                       AI Tracking free for the first month
//                                                       (with_free_ai_tracking: true)

const jsonHeaders = () => ({
    'Content-Type': 'application/json',
});

const csrfHeaders = () => ({
    'Content-Type': 'application/json',
    'X-CSRFToken': window.csrf_token,
});

export const getCurrentSubscription = () =>
    fetch('/api/v2/accounts/subscription/', {
        method: 'GET',
        headers: jsonHeaders(),
    });

export const getRegistrationInfo = () =>
    fetch('/api/v2/accounts/registration/', {
        method: 'GET',
        headers: jsonHeaders(),
    });

export const previewSubscriptionChange = (body) =>
    fetch('/api/v2/accounts/subscription/?preview=true', {
        method: 'PATCH',
        headers: csrfHeaders(),
        body: JSON.stringify(body),
    });

export const confirmAiTrialUpgrade = (body) =>
    fetch('/api/v2/accounts/subscription/', {
        method: 'PATCH',
        headers: csrfHeaders(),
        body: JSON.stringify(body),
    });
